import common from '../../common'

export const valueTable = {
  ...common.constants
}



// WEBPACK FOOTER //
// ./src/personnel/configs/commonConfig.js